@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_forms.scss";
@import "~/styles/v1/_spacing.scss";

.Select {
  @include form-input-base;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiA3TDEgMmwxLTEgNCA0IDQtNCAxIDEtNSA1eiIgZmlsbD0iIzg5OEVCNSIvPjwvc3ZnPg==);
  background-position: right center;
  background-repeat: no-repeat;
  background-size: 13px auto;

  &_empty {
    color: $system_eggplant-lightest;
  }

  &.Select_S {
    background-size: 10px auto;
  }

  &.Select_L,
  &.Select_XL {
    background-size: 15px auto;
  }

  // Outline
  &_outline {
    background-position: right $size-M center;
    box-shadow: none;
    height: 38px;
    padding: $size-S 35px $size-S $size-M;

    &.Select_S {
      background-position: right 5px center;
      height: 29px;
      padding: $size-XS $size-M $size-XS 9px;
    }

    &.Select_L,
    &.Select_XL {
      height: 49px;
      padding-right: 40px;
    }
  }

  // Underline & Silent
  &_underline,
  &_silent {
    background-position: right $size-XS center;
    height: 30px;
    padding: 0 $size-L 0 0;

    &.Select_S {
      height: 20px;
    }

    &.Select_L,
    &.Select_XL {
      height: 38px;
    }
  }
}
